import { render, staticRenderFns } from "./SeleccionRequisitos.vue?vue&type=template&id=114b1f81&"
import script from "./SeleccionRequisitos.vue?vue&type=script&lang=js&"
export * from "./SeleccionRequisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports